import { render } from "./paymentBannerComponent.vue?vue&type=template&id=81c52554"
import script from "./paymentBannerComponent.vue?vue&type=script&lang=js"
export * from "./paymentBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__